<template>
  <el-card shadow="never">
    <template slot="header">
      <span class="el-card__left">我的邀约</span>
    </template>
    <div v-loading="isLoading" class="bid-list">
      <template v-if="list.length > 0">
        <bid-item
          v-for="(item, index) in list"
          :key="index"
          :content-length="126"
          :value="item"
          :extra-detail-query="{ inviteId: item.inviteId }"
        />

        <el-pagination background layout="prev, pager, next, jumper" :current-page="pagination.current" :page-size="pagination.size" :total="pagination.total" @current-change="pageChange" />
      </template>

      <empty-layout v-else />
    </div>
  </el-card>
</template>

<script>
import BidItem from '@/components/BidItem'
import EmptyLayout from '@/components/EmptyLayout'
import { fetchMyInvitation } from '@/api'

export default {
  components: {
    BidItem,
    EmptyLayout
  },

  data() {
    return {
      list: [],

      pagination: {
        current: 1,
        size: 5,
        total: 0
      },

      isLoading: false
    }
  },

  mounted() {
    this.fetchInvitation()
  },

  methods: {
    fetchInvitation(page = 1) {
      this.isLoading = true
      fetchMyInvitation({
        pageSize: this.pagination.size,
        pageNo: page
      })
        .then(res => {
          const { records = [], total = 0 } = res.data

          this.list = records.filter(val => val.projectInfoDo).map(val => Object.assign(val.projectInfoDo, { inviteId: val.id }))
          this.pagination.total = total
        })
        .catch(err => {
          this.$message.error(err.message)
        })
        .finally(res => {
          this.isLoading = false
        })
    },

    pageChange(page) {
      document.documentElement.scrollTop = 0
      this.fetchInvitation(page)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-card__body {
  padding-top: 0 !important;
}
.el-pagination {
  display: table;
  margin: 20px auto 0;
}
</style>
